module.exports = __webpack_public_path__ + "media/country_flags/gh-8855fd69.png";